import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Components/Screens/Auth/Login';
import Dashboard from './Components/Screens/Main/Dashboard';
import CreateTransactionCategory from './Components/Screens/Main/CreateTransactionCategory';
import TransactionCategories from './Components/Screens/Main/TransactionCategories';
import CreatePaymentMethod from './Components/Screens/Main/CreatePaymentMethod';
import PaymentMethods from './Components/Screens/Main/PaymentMethods';
import CreateTransaction from './Components/Screens/Main/CreateTransaction';
import Portifolio from './Components/Screens/Main/Portifolio';
import Transactions from './Components/Screens/Main/Transactions'
import CreateSavingsGoals from './Components/Screens/Main/CreateSavingsGoals'
import SavingsGoals from './Components/Screens/Main/SavingsGoals'
import SavingsAnalysis from './Components/Screens/Main/SavingsAnalysis'


function App() {
  return (
    <div className="App">
      <Router>  
        <Routes>
          <Route path='/' element={<Portifolio />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/create-category" element={<CreateTransactionCategory />} />
          <Route path="/transaction-categories" element={<TransactionCategories />} />
          <Route path="/create-payment-method" element={<CreatePaymentMethod />} />
          <Route path="/payment-methods" element={<PaymentMethods />} />
          <Route path="/create-transaction" element={<CreateTransaction />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/create-savings-goal" element={<CreateSavingsGoals />} />
          <Route path="/savings-goals" element={<SavingsGoals />} />
          <Route path="/savings-analysis" element={<SavingsAnalysis />} />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
